import { jsPDF } from 'jspdf'
import { downloadNameForBatch } from './download'
import { MAX_QUEUE_ITEMS } from './fileValidation'

export interface ImageEntry {
  fileName: string
  blob: Blob
}

function imageTypeFor(blob: Blob): 'JPEG' | 'PNG' {
  return blob.type === 'image/jpeg' ? 'JPEG' : 'PNG'
}

export async function buildPdfBlob(pages: ImageEntry[]): Promise<Blob> {
  if (pages.length === 0) throw new Error('At least one converted image is required')
  if (pages.length > MAX_QUEUE_ITEMS) {
    throw new Error(`A PDF can contain up to ${MAX_QUEUE_ITEMS} pages per conversion`)
  }

  const pdf = new jsPDF({ unit: 'pt', format: 'a4', compress: true })
  for (const [index, page] of pages.entries()) {
    if (index > 0) pdf.addPage()
    let bytes: Uint8Array | undefined
    try {
      bytes = new Uint8Array(await page.blob.arrayBuffer())
      const properties = pdf.getImageProperties(bytes)
      const pageWidth = pdf.internal.pageSize.getWidth()
      const pageHeight = pdf.internal.pageSize.getHeight()
      const scale = Math.min(pageWidth / properties.width, pageHeight / properties.height)
      const width = properties.width * scale
      const height = properties.height * scale
      pdf.addImage(bytes, imageTypeFor(page.blob), (pageWidth - width) / 2, (pageHeight - height) / 2, width, height)
    } finally {
      bytes?.fill(0)
    }
  }
  return pdf.output('blob')
}

export function pdfDownloadName(): string {
  return downloadNameForBatch('pdf')
}